import { getStateName } from '../../model/authorDisplay';

import { Text } from '@/components/ui/text';

export const UserInfo = ({
  userType,
  state,
  isAnonymous = false,
}: {
  userType: string;
  state?: string;
  isAnonymous?: boolean;
}) => {
  if (isAnonymous) {
    return null;
  }

  return (
    <Text className="text-xs text-typography-700">
      {userType === 'expert' ? 'Primum Expert, ' : ''}
      {getStateName(state)}
    </Text>
  );
};
